enum StrategyNames {
  seven = 'seven',
  slave = 'slave',
  web_code = 'web_code',
}

export default StrategyNames;
